import { createApi } from "@reduxjs/toolkit/query/react";
import { apiFunction } from "./utils";
import { baseQueryWithReauth } from "./baseQueryWithReauth";

// Hasta ↔ klinik mesajları (sunucu: /api/clinic/messages, messages:read|send).
// Gerçek zamanlı kanal yok; sayfa görünürken sorgular periyodik yenilenir.
const BASE = "/api/clinic/messages";

export const messageApi = createApi({
  reducerPath: "messageApi",
  baseQuery: baseQueryWithReauth,
  tagTypes: ["Conversations", "Thread", "Unread"],
  keepUnusedDataFor: 30,
  endpoints: (b) => ({
    listConversations: b.query({
      query: (d) => apiFunction(d, `${BASE}/conversations`, "POST"),
      providesTags: ["Conversations"],
    }),
    messagesUnreadCount: b.query({
      query: (d) => apiFunction(d, `${BASE}/unread-count`, "POST"),
      providesTags: ["Unread"],
    }),
    messageThread: b.query({
      query: (d) => apiFunction(d, `${BASE}/thread`, "POST"),
      providesTags: ["Thread"],
    }),
    // Daha eski sayfalar (önbelleğe alınmaz; sayfa kendi state'inde biriktirir)
    olderMessages: b.mutation({ query: (d) => apiFunction(d, `${BASE}/thread`, "POST") }),
    sendMessage: b.mutation({
      query: (d) => apiFunction(d, `${BASE}/send`, "POST"),
      invalidatesTags: ["Conversations", "Thread", "Unread"],
    }),
    // WhatsApp "Yeni mesajınız var" şablonu (24 saat penceresi kapalıyken)
    // 24 saat penceresi kapalıyken listeden seçilen manuel WhatsApp şablonu ({ templateKey })
    sendMessageTemplate: b.mutation({
      query: (d) => apiFunction(d, `${BASE}/send-template`, "POST"),
      invalidatesTags: ["Conversations", "Thread"],
    }),
    markMessagesRead: b.mutation({
      query: (d) => apiFunction(d, `${BASE}/mark-read`, "POST"),
      invalidatesTags: ["Conversations", "Unread"],
    }),
  }),
});

export const {
  useListConversationsQuery,
  useMessagesUnreadCountQuery,
  useMessageThreadQuery,
  useOlderMessagesMutation,
  useSendMessageMutation,
  useSendMessageTemplateMutation,
  useMarkMessagesReadMutation,
} = messageApi;
